import type {
  NormalizedProjectionWithPlayer,
  PublishStreakProjectionsRequestData,
  StreakProjectionResponse
} from '@library/types/streaks';
import { api } from '@bo-services/api';
import { normalizeStreakProjection } from '@bo-utils/streaks';

export const streaksApi = api.injectEndpoints({
  endpoints: (build) => ({
    getStreakProjections: build.query<
      NormalizedProjectionWithPlayer[],
      {
        date: string;
        textSearch?: string;
        leagueId?: string;
        isOnStreakBoard?: boolean;
      }
    >({
      query: ({ date, textSearch, leagueId, isOnStreakBoard }) => ({
        url: '/admin/streaks/projections',
        params: {
          'q[start_date_eq]': date,
          'q[league_id_eq]': leagueId ?? undefined,
          'q[new_player_name_or_new_player_team_name_cont]': textSearch,
          'q[streak_rank_null]': !isOnStreakBoard
        }
      }),
      transformResponse: (response: StreakProjectionResponse) =>
        normalizeStreakProjection(response)
    }),
    publishStreakProjectionsBoard: build.mutation<
      void,
      PublishStreakProjectionsRequestData
    >({
      query: ({ date, projection_ids }) => ({
        url: `/admin/streaks/projections/${date}/sort`,
        method: 'POST',
        body: {
          projection_ids
        },
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      })
    })
  })
});

export const {
  useGetStreakProjectionsQuery,
  usePublishStreakProjectionsBoardMutation
} = streaksApi;
